import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="bg-[#0F1420] border border-[#232D42] rounded-2xl p-10 text-center max-w-md w-full" data-testid="payment-cancel">
        <XCircle size={44} className="mx-auto text-slate-500 mb-4" />
        <h1 className="font-heading text-2xl font-bold text-slate-100">Checkout canceled</h1>
        <p className="text-sm text-slate-400 mt-2">No charge was made. The launch pricing is still available if you change your mind.</p>
        <Link to="/pro" data-testid="cancel-back-btn" className="inline-block mt-5 bg-[#00E5A3] hover:bg-[#00C98E] text-[#04140F] font-semibold rounded-lg px-6 py-2.5">Back to plans</Link>
      </div>
    </div>
  );
}
